<template>
  <div class="modal-overlay">
    <div class="modal-content max-width-800">
      <div class="panel-title">
        <span>
          <button class="btn btn-transparent" value="daily" :class="{'active': period === 'daily'}" @click="fetchChartData('daily')">1 {{ $t('timeframe.day') }}</button>
          <button class="btn btn-transparent" value="weekly" :class="{'active': period === 'weekly'}" @click="fetchChartData('weekly')">1 {{ $t('timeframe.week') }}</button>
          <button class="btn btn-transparent" value="monthly" :class="{'active': period === 'monthly'}" @click="fetchChartData('monthly')">1 {{ $t('timeframe.month') }}</button>
          <button class="btn btn-transparent" value="quarterly" :class="{'active': period === 'quarterly'}" @click="fetchChartData('quarterly')">3 {{ $t('timeframe.month') }}</button>
          <button class="btn btn-transparent" value="half_year" :class="{'active': period === 'half_year'}" @click="fetchChartData('half_year')">6 {{ $t('timeframe.month') }}</button>
          <button class="btn btn-transparent" value="annual" :class="{'active': period === 'annual'}" @click="fetchChartData('annual')">1 {{ $t('timeframe.year') }}</button>
          <button class="btn btn-transparent" value="three_years" :class="{'active': period === 'three_years'}" @click="fetchChartData('three_years')">3 {{ $t('timeframe.year') }}</button>
          <button class="btn btn-transparent" value="max" :class="{'active': period === 'max'}" @click="fetchChartData('max')">{{ $t('timeframe.all') }}</button>
        </span>
        <span @click="closePanel"><i class="cursor-pointer ti-close right-side-toggle medium-icon"></i></span>
      </div>
      <div class="m-t-20">
        <h4>{{ this.symbol }}</h4>
      </div>
      <loading-container :loading="form.candleLoading">
        <div v-if="candleChart">
          <apexchart id="candlestickChart" class="candle-section" type="candlestick" height="290" :options="candleChart.chartOptions" :series="candleChart.series" />
        </div>
        <div v-if="volumeChart">
          <apexchart id="volumeChart" type="bar" height="250" :options="volumeChart.chartOptions" :series="volumeChart.series" />
        </div>
      </loading-container>
    </div>
  </div>
</template>

<script>
import ApexCharts from 'vue-apexcharts';
import { mapGetters, mapActions } from "vuex";
import LoadingContainer from "@/components/Misc/LoadingContainer";

export default {
  components: {
    apexchart: ApexCharts,
    LoadingContainer
  },
  props: {
    symbol: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters({
      form: "common/form",
      candleChart: "common/candleChart",
      volumeChart: "common/volumeChart",
    })
  },
  beforeMount() {
    this.fetchChartData(this.period);
  },
  data() {
    return {
      period: 'quarterly',
    }
  },
  methods: {
    ...mapActions({
      getPriceHistory: "common/getPriceHistoryByCode",
    }),
    fetchChartData(value) {
      this.period = value;
      const params = {
        'code': this.symbol,
        'period': this.period
      }
      this.getPriceHistory(params);
    },
    closePanel() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.volume-section {
  margin-top: 10px;
}

.candle-section {
  margin-left: -10px;
  margin-bottom: -60px;
}

.custom-tooltip {
  padding: 8px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  color: var(--gray-dark);
}
</style>
